// src/utils/slugify.js
// Single shared slug function so URL-building (NavBar) and
// URL-matching (ProductListing) always agree.
export const slugify = (str = "") =>
  str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");